import React from 'react';
import { User } from 'react-feather';

export const customerDetailButtonColumn = ({ getCustomerId, onClick }) => ({
    name: 'Müşteri',
    cell: row => {
        const customerId = getCustomerId(row);
        return customerId ? (
            <div
                className="btn btn-outline-primary"
                onClick={() => onClick(customerId)}
            >
                <User size={18} />
            </div>
        ) : '';
    },
    ignoreRowClick: true,
    center: true,
    button: true,
});

export const actionButtonColumn = ({ name, icon: Icon, onClick, isVisible, className }) => ({
    name,
    cell: row => {
        if (isVisible && !isVisible(row)) return '';
        return (
            <div
                className={className || 'btn btn-outline-warning'}
                onClick={() => onClick(row)}
            >
                <Icon size={18} />
            </div>
        );
    },
    ignoreRowClick: true,
    center: true,
    button: true,
});
